export class RecommendationBookFormInput{
    id: number
    title: string
    text: string
    recommendationTypeId: number
    isActive: boolean = false
    anonymousSender: boolean = false
    anonymousResponse: boolean = false
}